<template>
    <v-content :style="{color:style.fontColor}" v-if="userIsAuthenticated">
        <v-container >
            <v-row>
                <v-col cols="12">
                    <v-row>
                        <h1 :style="`color:${mainColor}`">Productos</h1>
                    </v-row>
                </v-col>
                <v-col class="text-center" cols="12" v-if="onLoading">
                    <loading-circular/>
                </v-col>
            </v-row>
            <v-row class="mb-5 mt-2"   >
                <v-col cols="2" offset="10" v-if="products.length > 0 && !onLoading">
                    <v-btn  :color="mainColor" dark @click="goToNew()">Nuevo producto</v-btn>
                </v-col>
            </v-row>
            <v-row class="pt-5" v-if="products.length === 0 && !onLoading">
              <v-col cols="12" class="text-center">
                <h4>Crea primero las categorías antes de agregar los productos</h4>
              </v-col>
              <v-col cols="12" class="text-center">
                  <v-btn  :color="mainColor" dark @click="goToNew()">Nuevo producto</v-btn>
              </v-col>
            </v-row>
            <v-row class="mb-5 mt-2"  v-if="products.length > 0">
                <v-col cols="12">
                <v-card>
                    <v-card-title>
                    <v-spacer></v-spacer>
                    <v-text-field
                        v-model="search"
                        :append-icon="searchIcon"
                        label="Buscar"
                        single-line
                        hide-details
                    ></v-text-field>
                    </v-card-title>
                    <v-data-table
                        :headers="headers"
                        :items="loadedProducts"
                        :search="search"
                        class="elevation-1"
                        :items-per-page = "itemsPerPageItems"
                        :page.sync="pagination"
                        :footer-props="{
                          itemsPerPageAllText:'Todo',
                          itemsPerPageText:'Filas por página'
                        }"
                        @page-count="pageCount = $event"
                    >
                        <template v-slot:item.status="{ item }">

                            {{ item.status === 'draft'? 'Borrador' : item.status === 'published'? 'Publicado' : 'Baja'}}
                        </template>
                        <template v-slot:item.creationDate="{ item }">
                            {{new Date(item.creationDate.seconds * 1e3).toString() | dateFilter}}
                        </template>
                        <template v-slot:item.imageUrl="{ item }">
                          <v-row justify="center" class="pa-3">
                            <v-img
                                :src="item.imageUrl === '' ? addImageIcon : item.imageUrl"
                                height="120"
                                max-width="170"
                                contain
                                eager
                            ></v-img>
                          </v-row>
                        </template>
                        <template v-slot:item.action="{ item }">
                          <v-row justify="center">
                            <v-btn :color="mainColor" outlined @click="goToEdit(item.productId)" icon class="mb-2">
                                <v-icon>{{editIcon}}</v-icon>
                            </v-btn>
                          </v-row>
                          <v-row justify="center">
                            <v-btn :color="mainColor" outlined @click="goToDelete(item.productId, item.productName, item.alterName1, item.alterName2, item.status, item.parentCategories)" icon>
                                <v-icon>{{deleteIcon}}</v-icon>
                            </v-btn>
                          </v-row>
                        </template>
                    </v-data-table>
                </v-card>
              </v-col>
            </v-row>
        </v-container>
    </v-content>
</template>
<script>
/* eslint-disable no-console */
import * as constants from '../../../constants.json'
import * as error from '../../../errorscode.json'
import { mdiMagnify, mdiPencilOutline, mdiDeleteOutline } from '@mdi/js'

export default {
  data () {
    return {
      products: [],
      companyId: '',
      companyName: '',
      mainColor: constants.MAINCOLOR,
      style: {
        border: '1px solid #e1e1e1',
        fontColor: '#525252'
      },
      pageCount: 0,
      search: '',
      itemsPerPageItems: 10,
      pagination: 1,
      headers: [
        { text: 'Nombre', value: 'productName' },
        { text: 'Descripción', value: 'shortDescription' },
        { text: 'Estado', value: 'status' },
        { text: 'Creado en', value: 'creationDate' },
        { text: 'Imagen', value: 'imageUrl', align: 'center' },
        { text: 'Acciones', value: 'action' }
      ],
      addImageIcon: constants.ADD_IMAGE_ICON,
      searchIcon: mdiMagnify,
      editIcon: mdiPencilOutline,
      deleteIcon: mdiDeleteOutline
    }
  },

  computed: {
    onLoading () {
      return this.$store.getters.getLoading
    },

    user () {
      return this.$store.getters.getUser
    },

    userIsAuthenticated () {
      return this.$store.getters.getUser !== null && this.$store.getters.getUser !== undefined
    },

    loadedProducts () {
      return this.$store.getters.getLoadedProducts
    }

  },

  watch: {
    /**
     * Fetching data if user is authenticated
     */
    async user (value) {
      // eslint-disable-next-line
      console.log('value', value)
      if (value === null || value === undefined) {
        this.$router.push('/')
      } else {
        await this.fetchData()
      }
    }
  },

  created () {
    this.fetchData()
  },

  methods: {
    async fetchData () {
      console.log('fetching data')
      try {
        const user = this.$store.getters.getUser
        console.log('user: ', user)
        if (user) {
          if (user.role === 'mega_administrator') {
            this.companyId = localStorage.companyId
          } else {
            const companyData = this.$store.getters.getCompanyData
            this.companyId = companyData.companyId
          }

          console.log('this.companyId', this.companyId)
          await this.$store.dispatch('actionLoadProducts', { companyId: this.companyId })
          this.products = this.$store.getters.getLoadedProducts
          console.log('this.products', this.products)
        }
      } catch (error) {
        throw error
      }
    },

    goToEdit (productId) {
      console.log('productId ', productId)
      if (this.$store.getters.getCompanyStatus === 'inactive') {
        alert(error.ERROR100)
      } else {
        this.$router.push({ name: 'EditProduct', params: { companyId: this.companyId, id: productId } })
      }
    },

    goToNew () {
      console.log('companyId ', this.companyId)
      if (this.$store.getters.getCompanyStatus === 'inactive') {
        alert(error.ERROR100)
      } else {
        this.$router.push({ name: 'CreateProduct', params: { companyId: this.companyId } })
      }
    },

    goToDelete (productId, productName, alterName1, alterName2, status, parentCategories) {
      console.log('companyId ', this.companyId)
      console.log('productId ', productId)
      if (this.$store.getters.getCompanyStatus === 'inactive') {
        alert(error.ERROR100)
      } else {
        confirm('¿Deseas eliminar este item?') && this.$store.dispatch('actionDeleteProduct', {
          companyId: this.companyId,
          productId,
          productName,
          alterName1,
          alterName2,
          status,
          parentCategories })
      }
    }
  }
}
</script>
